import { ChangeDetectionStrategy, Component } from "@angular/core";
import { IButtonDirective } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { OverlayLayoutComponent } from "@m19-board/overlay/overlay-layout/overlay-layout.component";
import { OverlayRule } from "@m19-board/overlay/overlay-service/overlay-rules";

@Component({
  selector: "app-manual-activation-required-overlay",
  imports: [TranslocoDirective, OverlayLayoutComponent, IButtonDirective],
  template: `
    <app-overlay-layout
      *transloco="let t"
      variant="info"
      icon="rocket"
      [title]="t('overlays.manual_activation_required_title')"
    >
      <p overlayBody>{{ t("overlays.manual_activation_required_reason") }}</p>
      <p overlayBody>{{ t("overlays.manual_activation_required_delay") }}</p>
      <a overlayCta iButton href="https://advertising.amazon.com/" target="_blank">
        {{ t("overlays.manual_activation_required_cta") }}
      </a>
    </app-overlay-layout>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManualActivationRequiredOverlayComponent {
  static readonly rule = OverlayRule.MANUAL_ACTIVATION_REQUIRED;
}
